import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id FE71CD75-B2E7-49A5-B00B-732BACB52F6F
 * name dolby
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dolby.svg
 * tags
 * - Audio 
 * - Brand / Logo 
 * - Home Automation 
 */
export const DolbyIcon = createSvgIcon(<><path d="M2,5V19H22V5H2M6,17H4V7H6C8.86,7.09 11.1,9.33 11,12C11.1,14.67 8.86,16.91 6,17M20,17H18C15.14,16.91 12.9,14.67 13,12C12.9,9.33 15.14,7.09 18,7H20V17Z" /></>, 'DolbyIcon');
export default DolbyIcon